/**
 * Design Tokens for Asset Detail Page
 * Dark glassmorphic gradient theme matching project aesthetic
 */

export const assetDetailStyles = {
  // Dark gradient page background
  pageBackground: "min-h-screen bg-gradient-to-br from-background via-background to-accent/20",
  
  // Glassmorphic premium cards
  premiumCard: "bg-gradient-to-br from-card/95 via-card/90 to-accent/5 backdrop-blur-xl border border-border/40 shadow-2xl ring-1 ring-primary/5 hover:shadow-[0_0_30px_rgba(245,158,11,0.15)] hover:ring-primary/20 transition-all duration-300",
  
  // Glassmorphic card (lighter version)
  glassmorphicCard: "bg-gradient-to-br from-card/80 via-card/70 to-accent/10 backdrop-blur-xl border border-border/50 shadow-xl ring-1 ring-primary/10",
  
  // Glassmorphic header
  compactHeader: "bg-gradient-to-r from-card via-card/98 to-accent/20 backdrop-blur-xl border-b border-border/50",
  
  // Decorative overlay
  decorativeOverlay: "absolute inset-0 bg-gradient-to-r from-primary/5 via-transparent to-accent/5 pointer-events-none",
  
  // Section spacing
  sectionSpacing: "space-y-6 p-6",
  
  // Gradient header for sections
  gradientHeader: "bg-gradient-to-r from-primary/10 via-accent/5 to-transparent border-l-4 border-primary/50 pl-4",
  
  // Interactive element
  interactiveElement: "transition-all duration-300 hover:shadow-[0_0_20px_rgba(245,158,11,0.2)] hover:scale-105",
  
  // Typography with gradients
  typography: {
    heroTitle: "text-2xl font-bold bg-gradient-to-r from-foreground to-foreground/80 bg-clip-text",
    sectionTitle: "text-xl font-semibold text-foreground",
    cardTitle: "text-lg font-semibold text-foreground",
    label: "text-sm font-medium text-muted-foreground uppercase tracking-wide",
    value: "text-base font-medium text-foreground",
  },
  
  // Stat cards with glow
  statCard: {
    container: "relative group bg-gradient-to-br from-card/80 via-card/70 to-accent/10 backdrop-blur-xl border border-border/50 shadow-xl ring-1 ring-primary/10 transition-all duration-300 hover:scale-105",
    glow: "absolute -inset-0.5 bg-gradient-to-r from-primary/20 to-accent/20 rounded-xl blur-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10",
    header: "pb-3 border-b border-border/30",
    content: "pt-3",
  },
  
  // Responsive grid
  responsiveGrid: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6",
  
  // Content section
  contentSection: "space-y-6 rounded-lg border border-border/40 bg-gradient-to-br from-card/95 via-card/90 to-accent/5 backdrop-blur-xl p-6 shadow-2xl ring-1 ring-primary/5",
} as const;

export type AssetDetailStyles = typeof assetDetailStyles;
